import React from "react";
import classes from "./CoachCardWithFavouriteIconMobile.module.css";
import PropTypes from "prop-types";
import {
  coachDemoImg,
  HeartIcon,
  HeartIconRed,
  LocationIconGray,
} from "../../constant/imagePath";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import StarRatings from "react-star-ratings";
import { ReactSVG } from "react-svg";
import { Button } from "../Button/Button";

export function CoachCardWithFavouriteIconMobile({
  data,
  showFavoriteIcon = false,
}) {
  return (
    <div className={classes.coachCard}>
      {/* Profile and User */}
      <div className={classes.cardHeader}>
        <img src={coachDemoImg} />
        <div>
          <div className={classes.headings}>
            <div>
              <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                {data?.firstName}
              </h5>
              <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                {data?.lastName}
              </h5>
            </div>
            {showFavoriteIcon && (
              <Button icon={HeartIconRed} className={classes.heartBtn} />
            )}
          </div>
          {/* Rating And Per Hour */}
          <div className={classes.ratingAndRate}>
            <p
              style={{ ...Fonts.b4, color: Colors.neutralShadesOfNero }}
              className={classes.starRating}
            >
              <StarRatings
                starRatedColor={Colors.mainShadeOfRed}
                starEmptyColor={Colors.neutralShadesOfDimGray}
                rating={data?.rating / 5}
                starDimension={"16px"}
                numberOfStars={1}
              />
              {data?.rating}
            </p>
            <span
              className={classes.dots}
              style={{ backgroundColor: Colors.neutralShadesOfDimGray }}
            />
            <p
              style={{
                ...Fonts.h7,
                lineHeight: "20px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              ${data?.price}
              <span style={{ ...Fonts.b4, color: Colors.neutralShadesOfNero }}>
                /hr
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className={classes.cardDesc}>
        <p style={{ ...Fonts.b2, color: Colors.neutralShadesOfDimGray }}>
          Professionally experienced knowledgeable coach of athletes from youths
          through collegiate level in tennis...
        </p>
        <div className={classes.locationAndSport}>
          <p
            style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
            className={classes.loc}
          >
            <ReactSVG
              src={LocationIconGray}
              beforeInjection={(svg) => svg.classList.add(classes.icon)}
            />{" "}
            {data?.distance} m away
          </p>
          <span
            className={[classes.dots].join(" ")}
            style={{
              backgroundColor: Colors.neutralShadesOfDimGray,
            }}
          />
          <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
            {data?.speciality}
          </p>
        </div>
      </div>
    </div>
  );
}

CoachCardWithFavouriteIconMobile.defaultProps = {
  data: {
    profile: coachDemoImg,
    firstName: "Benedict",
    lastName: "Cumberbatch",
    rating: 4.5,
    description:
      "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennis...",
    speciality: "Tennis",
    distance: "20",
  },
};
CoachCardWithFavouriteIconMobile.propTypes = {
  data: PropTypes.object,
};
